{
	"changeOrder": {
		"title": "Изменение ордера",
		"ticker": "Тикер",
		"option": "Опцион",
		"tickerCompany": "Тикер/Комп",
		"operation": "Операция",
		"quantity": "Количество",
		"sum": "Сумма",
		"profitability": "Доходность",
		"dateTime": "Дата/Время",
		"price": "Цена",
		"statusTitle": "Статус",
		"term": "Срок",
		"orderType": "Тип ордера",
		"orderDuration": "Срок",
		"stopPrice": "Стоп цена",
		"limitPrice": "Лимит цена",
		"approximateSum": "Примерная сумма",
		"availableFunds": "Доступные средства",
		"side": {
			"buy": "Купить",
			"sell": "Продать",
			"sell_short": "Продажа в шорт"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		},
		"types": {
			"market": "Рыночный",
			"limit": "Лимитный",
			"stop": "Стоп",
			"stop_limit": "Стоп-лимитный",
			"trailing_stop": "Трейлинг-стоп"
		},
		"attributes": {
			"stop_loss": "Stop Loss",
			"take_profit": "Take Profit"
		},
		"edit": "Изменить",
		"orderSuccessfullyChanged": "Ордер успешно изменен!",
		"couldn'tChangeOrder": "Не удалось изменить ордер."
	}
}
